import AvisHighTechLogo from './logo'
import {avisHighTechStylesFR} from './styles'

const baseConfig = {
  domainName: 'avishightech' as const,
  domainType: 'eu' as const,
  siteName: 'Avis High Tech',
  logo: <AvisHighTechLogo className="size-8 shrink-0 tablet:size-6" locale="fr" />,
  favicon: '/favicons/avishightech.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-X7B8LX5ZCF',
    camelCaseUrl: 'AvisHighTech.fr',
    title: (category: string, _count: string) => `Avis ${category} : Tests, Guides et Comparatifs Fiables`,
    description: (_category?: string, _count?: string) =>
      `Comparez les derniers produits high-tech grâce à des avis détaillés, des tests complets et des comparatifs objectifs pour bien choisir chaque achat.`,
    styles: avisHighTechStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
